var _defs, _path, _circle, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009e2a;}.cls-2{fill:#fff;}.cls-3{fill:#00dc3b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pharmacy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.4,0H16A16,16,0,0,0,0,15.92C0,26.83,14.3,42.85,14.9,43.55a1.45,1.45,0,0,0,2,0l0.05,0c0.6-.7,15-16.72,15-27.63A15.76,15.76,0,0,0,16.4,0h0ZM16,27.83a12,12,0,1,1,12-12A12,12,0,0,1,16,27.83Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 15.8,
    r: 12
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19 12.8 19 7.3 16 7.3 14.9 15.8 16 24.3 19 24.3 19 18.8 24.5 18.8 24.5 12.8 19 12.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13 7.3 13 12.8 7.5 12.8 7.5 18.8 13 18.8 13 24.3 16 24.3 16 7.3 13 7.3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.81fa311fb9797da17a38048bfed1b859.svg";
export { ForwardRef as ReactComponent };